import { createFeatureSelector, createSelector } from '@ngrx/store';

import { STUDIES_STATE_KEY } from '../studies.constants';
import * as studiesState from './studies.reducer';

export const studiesSelector = createFeatureSelector<studiesState.IStudiesState>(STUDIES_STATE_KEY);

export const allOrganizations = createSelector(
  studiesSelector,
  studiesState.organizations
);

export const researchStudies = createSelector(
  studiesSelector,
  studiesState.studies
);

export const researchStudyToEdit = createSelector(
  studiesSelector,
  studiesState.researchStudyToEdit
);

export const studyListNavigator = createSelector(
  studiesSelector,
  studiesState.studyListNavigator
);

export const therapeuticAreas = createSelector(
  studiesSelector,
  studiesState.therapeuticAreas
);
